// extracted by mini-css-extract-plugin
export default {"TVmodal":"styles_TVmodal__GZnI8","message":"styles_message__j9+Lm","right":"styles_right__-ttgc","calltoaction":"styles_calltoaction__4oAb7"};